<div
  [formGroup]="form"
  [class.content]="!disableCropFieldSelector()"
  [class.content-embedded]="disableCropFieldSelector()"
>
  <div
    class="flex flex--row full-width flex--align-center header"
    [class.flex--justify-space-between]="!disableCropFieldSelector()"
    [class.flex--justify-end]="disableCropFieldSelector()"
  >
    @if (!disableCropFieldSelector()) {
      <div class="flex__child">
        <div class="custom-selector">
          <label class="placeholder" id="cropFieldSelectLabel" for="cropFieldSelect">{{
            'blightV2.shared.selectCropField' | translate
          }}</label>
          <div class="crop-field-select-sizer">
            <span class="crop-field-select-sizer__text" aria-hidden="true">{{ longestOptionText() }}</span>
            <mat-select
              formControlName="cropField"
              panelClass="disease-crop-field-select-panel"
              id="cropFieldSelect"
              aria-labelledby="cropFieldSelectLabel"
            >
              @for (cropField of cropFields(); track cropField.cropFieldId) {
                <mat-option [value]="cropField.cropFieldId">{{ cropField.cropFieldName }}</mat-option>
              }
            </mat-select>
          </div>
        </div>
        @if (selectedCropFieldAdvice()?.cropVarietyName) {
          <span class="crop-variety-label"
            ><strong>{{ 'BFP.UI.Variety' | translate }}:</strong> {{ selectedCropFieldAdvice()?.cropVarietyName }}</span
          >
        }

        <button
          mat-flat-button
          color="accent"
          class="action-button"
          [matMenuTriggerFor]="downyMildewMenu.menu"
          (menuOpened)="onActionMenuOpened('button')"
        >
          <mat-icon class="table-toolbar-button-icon action-button-icon">add_task</mat-icon>
          <span class="flex--align-center table-toolbar-button-span">
            {{ 'shared.diseaseTable.actions' | translate }}
            <mat-icon>keyboard_arrow_down</mat-icon>
          </span>
        </button>
      </div>
    }

    <div class="flex">
      <div class="flex--row">
        <app-recalculate-button
          (recalculate)="onRecalculate()"
          [disabled]="isRecalculationDisabled()"
          [disabledTooltip]="isCropYearReadOnly() ? ('UI.CurrentYearOnlyMutationMessage' | translate) : ''"
          [isLoading]="store.isDownyMildewCropFieldsSyncing()"
          [label]="'shared.diseaseTable.recalculateAdviceInsight' | translate"
        />
      </div>
      <div class="flex--row flex--align-center table-toolbar-button-group">
        <app-date-selector
          [minimalDate]="minimalDate()"
          [maximalDate]="maximalDate()"
          [selectedDates]="selectedDates()"
          [cropYear]="store.cropYear()"
          (selectedDatesChanges)="onSelectedDatesChanged($event)"
        />
      </div>
    </div>
  </div>

  @if (selectedCropField(); as cropField) {
    <div class="toolbar-container">
      <app-disease-insight-toolbar
        [selectedCropField]="cropField"
        [plantDateConfig]="plantDateFieldConfig()"
        [emergenceDateConfig]="emergenceDateFieldConfig()"
        [harvestDateConfig]="harvestDateFieldConfig()"
        (readonlyDateActionTriggered)="onGrowthStageEditClicked($event)"
        (plantDateChanged)="onPlantDateChanged($event)"
        (emergenceDateChanged)="onThirdLeafStageDateChanged($event)"
        (harvestDateChanged)="onLeavesBentOverDateChanged($event)"
      />
    </div>
  }

  @if (store.selectedCropFieldId()) {
    <app-disease-insight-chart
      [selectedRange]="selectedDates()"
      [chartDays]="chartDays()"
      [advice]="adviceForChart()"
      [riskTableRowsTemplate]="riskTableRows"
      (actionTriggered)="onActionTriggered($event)"
      (seriesToggled)="onGraphSeriesToggled($event)"
    />
  }
</div>

<span
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="downyMildewMenu.menu"
  (menuOpened)="onActionMenuOpened('chart')"
  style="position: fixed; visibility: hidden; pointer-events: none"
></span>
<app-downy-mildew-action-menu
  #downyMildewMenu
  [advices]="selectedAdvice()"
  [actionDate]="actionDate()"
  context="insights"
/>

<ng-template #riskTableRows let-days let-chart="chart">
  <tr class="details-row">
    <td class="no-borders">
      <div class="hover-text">
        <img alt="" src="assets/icons/combined_risk.svg" />
        <span class="tooltip-text right">{{ 'downyMildew.riskChart.combinedRisk' | translate }}</span>
      </div>
    </td>
    @for (day of days; track day.date) {
      <td
        class="risk-cell"
        [style]="getRiskCellStyle(day, 'combinedRisk')"
        (mouseenter)="chart.showTooltip($event, tooltipFormatter(day, 'combinedRisk'))"
        (mouseleave)="chart.hideTooltip()"
      ></td>
    }
  </tr>

  <tr class="details-row">
    <td class="no-borders">
      <div class="hover-text">
        <img alt="" src="assets/icons/sporulation_risk.svg" />
        <span class="tooltip-text right">{{ 'downyMildew.riskChart.sporulationRisk' | translate }}</span>
      </div>
    </td>
    @for (day of days; track day.date) {
      <td
        class="risk-cell"
        [style]="getRiskCellStyle(day, 'sporulationRisk')"
        (mouseenter)="chart.showTooltip($event, tooltipFormatter(day, 'sporulationRisk'))"
        (mouseleave)="chart.hideTooltip()"
      ></td>
    }
  </tr>

  <tr class="details-row">
    <td class="no-borders">
      <div class="hover-text">
        <img alt="" src="assets/icons/infection_risk.svg" />
        <span class="tooltip-text right">{{ 'downyMildew.riskChart.infectionRisk' | translate }}</span>
      </div>
    </td>
    @for (day of days; track day.date) {
      <td
        class="risk-cell"
        [style]="getRiskCellStyle(day, 'infectionRisk')"
        (mouseenter)="chart.showTooltip($event, tooltipFormatter(day, 'infectionRisk'))"
        (mouseleave)="chart.hideTooltip()"
      ></td>
    }
  </tr>
</ng-template>
